import { usePostApiV1ThreeLetterCodeClientAdminsStressAssessments } from '@fukuri-admins/apis/client/gen/endpoints';

export const usePostStressAssessments = usePostApiV1ThreeLetterCodeClientAdminsStressAssessments;
